<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2" id="toc"><a id="page_v"></a><strong>Contents</strong></h2>
<p class="tocfront"><a class="nounder" href="#/xhtml/acknowledgments#acknowledgments"><em>Acknowledgments</em></a></p>
<p class="tocpart"><a class="nounder" href="#/xhtml/pt01#pt01"><span class="small">PART I:</span> Sephardic Jewry in the Middle Ages: Origins, Development, and Flowering</a></p>
<p class="tocchap"><a class="nounder" href="#/xhtml/ch01#ch01">1 A Global Perspective on Sephardic and Mizrahi Jewry: An Introductory Essay</a></p>
<p class="tocauthor"><em>Zion Zohar</em></p>
<p class="tocchap"><a class="nounder" href="#/xhtml/ch02#ch02">2 The Origins of Sephardic Jewry in the Medieval Arab World</a></p>
<p class="tocauthor"><em>Mark R. Cohen</em></p>
<p class="tocchap"><span class="nounder" href="#/xhtml/ch03#ch03" title="Link target outside of Sample">3 The Judeo-Arabic Heritage</span></p>
<p class="tocauthor"><em>Norman A. Stillman</em></p>
<p class="tocchap"><span class="nounder" href="#/xhtml/ch04#ch04" title="Link target outside of Sample">4 Judeo-Spanish Culture in Medieval and Modern Times</span></p>
<p class="tocauthor"><em>David M. Bunis</em></p>
<p class="tocchap"><span class="nounder" href="#/xhtml/ch05#ch05" title="Link target outside of Sample">5 Literatures of Medieval Sepharad</span></p>
<p class="tocauthor"><em>Jonathan P. Decter</em></p>
<p class="tocchap"><span class="nounder" href="#/xhtml/ch06#ch06" title="Link target outside of Sample">6 Medieval Sephardic-Oriental Jewish Bible Exegesis: The Contributions of Saadia Gaon and Abraham ibn Ezra</span></p>
<p class="tocauthor"><em>Isaac Kalimi</em></p>
<p class="tocchap"><span class="nounder" href="#/xhtml/ch07#ch07" title="Link target outside of Sample">7 Jewish Philosophy and Kabbalah in Spain</span></p>
<p class="tocauthor"><em>Moshe Idel</em></p>
<p class="tocpart"><a id="page_vi"></a><span class="nounder" href="#/xhtml/pt02#pt02" title="Link target outside of Sample"><span class="small">PART II:</span> From Expulsion to the Modern Era: Exile, Decline, and Revival</span></p>
<p class="tocchap"><span class="nounder" href="#/xhtml/ch08#ch08" title="Link target outside of Sample">8 Hispanic Culture in Exile: Sephardic Life in the Ottoman Balkans</span></p>
<p class="tocauthor"><em>Annette B. Fromm</em></p>
<p class="tocchap"><span class="nounder" href="#/xhtml/ch09#ch09" title="Link target outside of Sample">9 Sephardic Jurisprudence in the Recent Half-Millennium</span></p>
<p class="tocauthor"><em>Zvi Zohar</em></p>
<p class="tocchap1"><span class="nounder" href="#/xhtml/ch10#ch10" title="Link target outside of Sample">10 Safed Kabbalah and the Sephardic Heritage</span></p>
<p class="tocauthor"><em>Morris M. Faierstein</em></p>
<p class="tocchap1"><span class="nounder" href="#/xhtml/ch11#ch11" title="Link target outside of Sample">11 Jewish Women in the Ottoman Empire</span></p>
<p class="tocauthor"><em>Paméla Dorn Sezgin</em></p>
<p class="tocpart"><span class="nounder" href="#/xhtml/pt03#pt03" title="Link target outside of Sample"><span class="small">PART III:</span> Sephardic Jewry in the Modern Era and Special Topics</span></p>
<p class="tocchap1"><span class="nounder" href="#/xhtml/ch12#ch12" title="Link target outside of Sample">12 Early Modern Sephardim and Blacks: Contact and Conflict between Two Minorities</span></p>
<p class="tocauthor"><em>Jonathan Schorsch</em></p>
<p class="tocchap1"><span class="nounder" href="#/xhtml/ch13#ch13" title="Link target outside of Sample">13 Diversity and Uniqueness: An Introduction to Sephardic Liturgical Music</span></p>
<p class="tocauthor"><em>Mark Kligman</em></p>
<p class="tocchap1"><span class="nounder" href="#/xhtml/ch14#ch14" title="Link target outside of Sample">14 A Double Occlusion: Sephardim and the Holocaust</span></p>
<p class="tocauthor"><em>Henry Abramson</em></p>
<p class="tocchap1"><span class="nounder" href="#/xhtml/ch15#ch15" title="Link target outside of Sample">15 Sephardim and Oriental Jews in Israel: Rethinking the Sociopolitical Paradigm</span></p>
<p class="tocauthor"><em>Zion Zohar</em></p>
<p class="tocback"><span class="nounder" href="#/xhtml/contributors#contributors" title="Link target outside of Sample"><em>About the Contributors</em></span></p>
<p class="tocback"><span class="nounder" href="#/xhtml/index#index" title="Link target outside of Sample"><em>Index</em></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?28c1d507